import React, { useState } from "react";

import Typography from "../../components/Typography";

import { ReactComponent as DocumentTextIcon } from "../../build/images/nps-dashboard-icons/document-text.svg";
// import { ReactComponent as MessageQuestionIcon } from "../../build/images/nps-dashboard-icons/message-question.svg";
import { ReactComponent as StartIcon } from "../../build/images/nps-dashboard-icons/star.svg";

import "./nps-details.css";

export default function NpsDetailsCopy({ search, details, help, actions }) {
  const [activeTab, setActiveTab] = useState("search");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="nps-details-container column right active" id="nps-detail">
      {/*<nav className="nps-details-nav">
                <div className="nps-details-nav-content">
                    <div
                        className={`details-tab ${activeTab === "details" ? "active" : ""}`}
                        onClick={() => handleTabClick("details")}
                    >
                        <div className="details-tab__content">
                            <span className="details-tab__content__span">
                                <DocumentTextIcon />
                                <Typography.H4
                                    weight={activeTab === "details" ? "700" : "500"}
                                    color={activeTab === "details" ? "blue-selected-4" : "gray-180"}
                                >
                                    Detalhes
                                </Typography.H4>
                            </span>
                            {activeTab === "details" && <div className="underline" />}
                        </div>
                    </div>

                    <div
                        className={`search-tab ${activeTab === "search" ? "active" : ""}`}
                        onClick={() => handleTabClick("search")}
                    >
                        <div className="search-tab__content">
                            <span className="search-tab__content__span">
                                <StartIcon />
                                <Typography.H4
                                    weight={activeTab === "search" ? "700" : "500"}
                                    color={activeTab === "search" ? "blue-selected-4" : "gray-180"}
                                >
                                    Pesquisa
                                </Typography.H4>
                            </span>
                            {activeTab === "search" && <div className="underline" />}
                        </div>
                    </div>

                    {<div
                        className={`help-tab ${activeTab === "help" ? "active" : ""}`}
                        onClick={() => handleTabClick("help")}
                    >
                        <div className="help-tab__content">
                            <span className="help-tab__content__span">
                                <MessageQuestionIcon />
                                <Typography.H4
                                    weight={activeTab === "help" ? "700" : "500"}
                                    color={activeTab === "help" ? "blue-selected-4" : "gray-180"}
                                >
                                    Ajuda
                                </Typography.H4>
                            </span>
                            {activeTab === "help" && <div className="underline" />}
                        </div>
                    </div>}
                </div>
            </nav>*/}

      {actions && <>{actions}</>}

      {activeTab === "search" && search && <>{search}</>}

      {activeTab === "help" && help && <>{help}</>}

      {activeTab === "details" && details && <>{details}</>}
    </div>
  );
}
